import { useBindProp as e } from "../props.js";
import { makeOptionsSetter as t } from "../../utils/options.js";
import { LineJoins as r, LineCaps as i } from "../../utils/types.js";
import o from "./base.js";
var s = t("lineJoin"),
    n = t("lineCap"),
    l = t("showDir"),
    u = t("dirColor"),
    d = t("dirImg"),
    p = t("isOutline"),
    m = t("outlineColor"),
    a = t("borderWeight"),
    f = t("geodesic");

function c(t, c) {
  o(t, c), e(t, {
    setter: s,
    validate: function validate(e) {
      return r.includes(e);
    }
  }, c.lineJoin), e(t, {
    setter: n,
    validate: function validate(e) {
      return i.includes(e);
    }
  }, c.lineCap), e(t, {
    setter: l
  }, c.showDir), e(t, {
    setter: u
  }, c.dirColor), e(t, {
    setter: d
  }, c.dirImg), e(t, {
    setter: p
  }, c.isOutline), e(t, {
    setter: m
  }, c.outlineColor), e(t, {
    setter: a
  }, c.borderWeight), e(t, {
    setter: f
  }, c.geodesic);
}

export default c;